import { Injectable } from '@angular/core';
import { ActiveService } from './active.service';
import Graphic from '@arcgis/core/Graphic';
import Collection from '@arcgis/core/core/Collection';
import Point from '@arcgis/core/geometry/Point';
import SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import MapView from '@arcgis/core/views/MapView';
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";

@Injectable({
  providedIn: 'root',
})
export class MapService {
  currentCategory: string = '';
  currentLayer: string = '';
  currentForm: string = '';
  currentFormId: string = '';  // este es el id del formulario
  //depende de cuantos recorridos existan- Master asume un unico recorrido
  markersLayer: any;
  markersLayerView: any;
  //depende de cuantos recorridos existan
  dataMarkers: any;
  markersSource = new Collection();
  mapView: MapView;
  highlight: any;
  sceneActiveStart: any;
  layer: any;
  lastHlookAt: number;
  newScene: boolean = false;
  showPano: boolean = false;
  currentScene: any;
  view: any

  constructor(
    private activeService: ActiveService,
  ) { }

  setViewMap(map) {
    this.mapView = map;
  }

  getViewMap() {
    return this.mapView;
  }

  activeScene(krpano) {
    let setActiveMarker = () => {
      this.currentScene = krpano.get('scene[get(xml.scene)].name');
      let query = this.layer.createQuery();
      query.where = `LOWER(scene) ='${this.currentScene}'`;
      this.layer.queryFeatures(query)
        .then(function (response) {
          if (response) {
            this.newScene = true;
            let activeMarker = response.features[0].geometry;

            this.getHorizontalDirection(krpano, activeMarker);

            this.mapView.goTo(activeMarker); // aca se pasa la geometria del punto --DS
            this.mapView.zoom = 19;
          }
        }.bind(this)
        );
    };
    krpano.set('events.onnewscene', setActiveMarker);
  }

  drawMarker(feature, hlookat) {
    this.mapView.graphics.removeAll()
    const symbol = {
      type: "picture-marker",
      url: "assets/img/SVG/RealGISicon_compass.svg",
      width: 32,
      height: 32,
      angle: hlookat
    };

    let directionGraphic = new Graphic({
      geometry: feature,
      //@ts-ignore
      symbol: symbol,
    });

    this.mapView.graphics.add(directionGraphic);
    this.newScene = false;
    this.lastHlookAt = hlookat;
  }

  getHorizontalDirection(krpano, feature) {

    let viewChange = () => {

      // this line is mandatory to get values between 0 and 360 --DS
      krpano.call("adjusthlookat(180)");

      let hlookat: number = krpano.get('view.hlookat');
      if (hlookat !== this.lastHlookAt || this.newScene) {
        this.drawMarker(feature, hlookat);

      }
    };

    krpano.set('events.onviewchange', viewChange)
  }

  addMarkersLayer(krpano) {

    this.layer = this.mapView.map.allLayers.find(function (layer) {
      return layer.title.toLowerCase().includes('hotspot') && layer.type === 'feature';
    });

    this.layer.visible = true
    this.layer.outFields = ["*"];

    this.mapView.whenLayerView(this.layer).then(layerView => {
      this.view = layerView

    });
    
    this.layer
      .when(() => {
        return this.layer.queryExtent();
      })
      .then((response) => {
        this.mapView.goTo(response.extent);
      });
    this.activeScene(krpano);

    //this is simbology based on zoom level --DS
    reactiveUtils.when(() => this.mapView.stationary === true, () => {
      let radius: number;

      if (this.mapView.zoom > 19) {
        radius = (this.mapView.zoom - 10);
      } else {
        radius = 5;
      }
      this.layer.renderer.symbol.size = radius;
    });


    this.mapView.on(
      'click',
      function (event) {
        const opts = {
          include: this.layer,
        };
        this.mapView.hitTest(event, opts).then((response) => {
          if (response.results.length) {
            if (!this.showPano) { this.showPano = true; }
            const graphic = response.results[0].graphic;
            let sceneXml = graphic.attributes.xml_origen;
            let sceneName = graphic.attributes.scene;
            krpano.call(
              `loadpanoscene(xml/${sceneXml},${sceneName}, null, MERGE, NOBLEND);`
            );
          }
        });
      }.bind(this)
    );
  }

  removeMarkers() {
    this.layer.visible = false;
    this.newScene = false
    this.mapView.graphics.removeAll();
    this.showPano = false;
  }

  addActives() {

    if (this.currentFormId != "") {

      let activeSymbol = {
        type: 'simple-marker',
        color: 'yellow',
        size: 12,
        style: 'triangle',
        outline: {
          color: 'black',
          width: 0.4,
        },
      };

      var filter = {
        formulario_id: this.currentFormId,
      };

      let activesSource = new Collection();
      activesSource.removeAll();
      this.activeService.getActivesFilter(filter).subscribe((data: {}) => {
        Object.entries(data["SDTFormularioCapturaFiltro"]).forEach(
          ([key, value]) => {
            let marker = new Graphic({
              geometry: new Point({
                latitude: value["formulario_captura_latitud"],
                longitude: value["formulario_captura_longitud"],
              })
            });
            activesSource.add(marker);
          }
        );
        let activesLayer = new FeatureLayer({
          source: activesSource,
          objectIdField: 'ObjectID',
          geometryType: 'point',

          renderer: new SimpleRenderer({
            symbol: activeSymbol,
          }),
          popupEnabled: false,
          visible: true,
          title: 'Activos',
        });
        this.mapView.map.layers.find(function (layer) {
          if (layer.title === 'Activos') {
            this.mapView.map.remove(layer);
          }
          return true
        }.bind(this));
        this.mapView.map.add(activesLayer);
      });
    }
  }

  setCurrentCategory(category) {
    this.currentCategory = category;
  }

  setCurrentLayer(layer) {
    this.currentLayer = layer;
  }

  setCurrentForm(form) {
    this.currentForm = form;
  }

  setCurrentFormId(formId) {
    this.currentFormId = formId;
  }

  getCurrentCategory() {
    return this.currentCategory;
  }

  getCurrentLayer() {
    return this.currentLayer;
  }

  getCurrentForm() {
    return this.currentForm;
  }

  getCurrentFormId() {
    return this.currentFormId;
  }
}
